/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSquareChevronsUp = createReactComponent(
  "square-chevrons-up",
  "IconSquareChevronsUp",
  [
    ["path", { d: "M9 16l3 -3l3 3", key: "svg-0" }],
    ["path", { d: "M9 11l3 -3l3 3", key: "svg-1" }],
    [
      "path",
      {
        d: "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z",
        key: "svg-2"
      }
    ]
  ]
);

export { IconSquareChevronsUp as default };
//# sourceMappingURL=IconSquareChevronsUp.js.map
